'use strict';

namespace TR {

    class AccountSignIn {

        path: string;
        postSignIn: Function;

        private noBufferUrls: string[] = ['signin', 'signup', 'bookingsignin'];
        private options: Object; //options that are passed down to the modal

        constructor(
            private $location: ng.ILocationService,
            private $route: any,
            private accountMenuService: any,
            private authService: any,
            private urlUtils: any
        )
        { }

        public popupSignIn = (event) => {
            event.preventDefault();

            const parsedUrl = this.urlUtils.parse(this.$location.url());
            parsedUrl.url = this.urlUtils.stripLeadingSlash(parsedUrl.url);
            parsedUrl.qs.pb = 1;

            const cookieName = this.authService.createCookieName();
            this.authService.doesHttpOnlyCookieExist(cookieName);

            const bufferRedirect = this.noBufferUrls.every(bUrl => parsedUrl.url.indexOf(bUrl) < 0)
                                        && this.noBufferUrls.some(bUrl => this.path.indexOf(bUrl) > -1);

            const redirect = this.urlUtils.format(parsedUrl);

            const currentRoute = this.$route && this.$route.current && this.$route.current.$$route;

            this.authService.bufferRoute(redirect);

            this.authService.bufferRoute(bufferRedirect
                                            && currentRoute
                                            && !currentRoute.requiresAnonAuth
                                            && !currentRoute.requiresHardAuth
                                         ? redirect : '/');

            //redirect here is only used in the mobile version of accountMenuService
            this.accountMenuService.launchOption(this.path, this.options, redirect);

            if (this.postSignIn) {
                this.postSignIn();
            }
        }
    }


    angular
        .module('TR')
        .directive('accountSignIn', () => {
            return {
                scope: {},
                bindToController: {
                    path: '@',
                    postSignIn: '&',
                    options: '='
                },
                controller: AccountSignIn,
                controllerAs: 'as',
                restrict: 'E',
                replace: true,
                template: '<a href="#" ng-click="as.popupSignIn($event)" ng-transclude></a>',
                transclude: true
            };
        });
}
